// extracted by mini-css-extract-plugin
export default {"pageWrap":"aa-z","fullWidth":"ba-z","heading":"ca-z","fullBleed":"da-z","hidden":"ea-z"};